import { IonLabel } from "@ionic/react";
import React from "react";

export interface ProfileInputWrapProps {
  type: string;
  label?: string;
}

const ProfileInputWrap: React.FC<ProfileInputWrapProps | any> = (props) => (
  <div className={[`collapse-form__field collapse-form__field--type-${props.type} `, props.className].join(props.className)}>
    {props.children}
    {props.label && !!props.label.length && <IonLabel className="input__label">{props.label}</IonLabel>}
  </div>
);

export default ProfileInputWrap;
